module.exports = __webpack_public_path__ + "static/media/xlsx_grey.e48d0767.svg";